<template>
  <div class="money-pay">
    <div class="No_preferential" v-if="rechangeData == ''">
      <img src="@public/img/pay/zanwuyouhui.png" alt />
      <p>暂无充值项</p>
      <img src="weixin://wxpay/bizpayurl?pr=ni4xDOnzz" alt="" />
    </div>

    <div class="preferential" v-else>
      <div
        v-for="(item, index) in rechangeData.rule"
        :class="
          nowIdx == index ? 'rechangeItem rechangeItemActive' : 'rechangeItem'
        "
        :key="index"
        @click="selectRechange(index)"
      >
        <div class="item">充{{ item.charge_money }}元</div>
        <div class="item2">
          送{{ item.money_status != 0 ? item.money : 0 }}元
        </div>
        <!-- 三角 -->
        <div class="triangle"></div>
      </div>
      <!-- 詳細 -->
      <div v-if="nowIdx != 'a'" class="option">
        {{
          rechangeData.rule[nowIdx].point_status != 0
            ? "赠送" + rechangeData.rule[nowIdx].point + "积分"
            : ""
        }}
        <span v-if="rechangeData.rule[nowIdx].coupon_status != 0">
          <template v-for="item in rechangeData.rule[nowIdx].coupon_data">
            {{ "赠送" + item.couponNum + "张" + item.title + "优惠券" }} /
          </template>
        </span>
        <span v-if="rechangeData.rule[nowIdx].is_unify != 0">
          <template v-for="item in rechangeData.rule[nowIdx].newUnify">
            {{ "赠送" + item.name + "加油时优惠" + item.money + "元" }} /
          </template>
        </span>
        <span v-if="rechangeData.rule[nowIdx].is_lock != 0">
          <template v-for="item in rechangeData.rule[nowIdx].newLock">
            {{ "赠送" + item.name + "加油时每升油价" + item.money + "元" }} /
          </template>
        </span>
      </div>
    </div>
    <div style="margin-bottom: 4px">
      <el-card class="box-card pay_infor" v-if="nowIdx == 'a'">
        <div class="pay_price">
          <span>支付金额:</span>
          <div class="price">
            ￥
            <span v-if="inputPrice">{{ inputPrice }}</span>
            <span v-else>0</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card pay_infor">
        <div class="selectPay_type">
          <div
            v-for="(item, index) in pay_type"
            :key="index"
            class="pay_type"
            @click="chosePayType(index)"
            :class="payIndex == index ? 'pay_type_Active' : ''"
          >
            <img :src="item.imgUrl" alt v-if="item.imgStatus" />
            <span v-else>账户：{{ item.balance }}</span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card pay_infor">
        <el-input placeholder="备注" v-model="remarkInput" clearable></el-input>
      </el-card>
      <el-card class="box-card pay_infor submitAccounts" style="margin:0">
        <el-button type="success" plain @click="antiShake">
          <img src="@public/img/pay/jiezhang.png" alt />
          <span>充值</span>
        </el-button>
        <paySuccess ref="pay_Success" @payEnd="payEnd"></paySuccess>
      </el-card>
    </div>
    <el-dialog
      :title="this.pay_type[this.payIndex].name + '扫码支付'"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div class="qrcode-con" id="qrcode"></div>
    </el-dialog>
    <el-dialog
      title="等待用户刷卡"
      :visible.sync="dialogVisiblePos"
      width="400px"
      :before-close="handleClosePos"
    >
      <!-- <div>请用户出示银行卡进行刷卡支付！！！</div> -->
      <img src="@public/img/wait.gif" alt="" style="width: 100%" />
    </el-dialog>
    <el-dialog
      title="等待用户出示付款码"
      :visible.sync="dialogVisibleScancode"
      width="400px"
      style="padding: 0;overflow: hidden"
      :before-close="handleClosePos"
      destroy-on-close
    >
      <div v-loading="loading" element-loading-text="支付中...">
        <img
          src="@public/img/saoma.gif"
          alt=""
          style="width: 360px;height: 340px"
        />
        <el-input
          style="opacity:0;width:10px;height: 2px"
          ref="inputbox_pay"
          @change="keyup_submit"
          size="mini"
          v-model="pay_code"
          @blur="Blur"
        ></el-input>
      </div>
    </el-dialog>
    <!-- ，短信验证弹窗 -->
    <el-dialog
      :visible.sync="verificationStatus"
      title="短信验证"
      width="400px"
      :before-close="handleNote"
    >
      <el-form ref="form" label-width="100px">
        <div>
          <el-form-item label="验证码">
            <el-input class="input_box" v-model="verification_code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="antiShake">
          确认
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { recharge_order_query, recharge_order_queryss } from "@/api/vip";
import QRCode from "qrcodejs2";
import { getConfigButton } from "@/api/set";
import { iCSendSms, rechargeDetail, rechargePay, searchOrder } from "@/api/ic";
import paySuccess from "./paySuccessRechange";
import verificationCode from "@/utils/verificationCode";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    paySuccess,
    QRCode,
  },
  props: [
    "inputPrice",
    "integralNum",
    "user_infor",
    "recharge_info",
    "send_money",
    "rechangeData",
  ],
  data() {
    return {
      result: null,
      loading: false,
      saomaForm: {},
      pay_code: "",
      dialogVisibleScancode: false,
      dialogVisible: false,
      dialogVisiblePos: false,
      payPrice: 0, // 最终支付金额
      openMutex: false, // 积分互斥规则
      vipdiscounts: "", // 会员优惠
      conponList: [], // 优惠券列表
      conponType: "",
      useNum: 0, // 当前选中优惠券的数量
      bottom_ticket: `选择优惠券`, //优惠券提示
      couponIds: "", //优惠券id串
      upPrice: 0, // 上一次优惠券抵扣金额
      nowconponIdx: "", // 优惠券idx
      dedIntegral: 0, // 使用的抵扣积分
      dedIntegralMoney: 0, // 抵扣积分减免的钱
      conponOwnNum: 0,
      vipdiscounts_status: 0,
      activeName: "1",
      openIntegral: false, // 是否启用积分
      num: "",
      couponradio: "",
      showDiscounts: false,
      remarkInput: "", // 备注
      drawer: false,
      payIndex: "0", // 支付方式选项
      link: "www.baidu.com",
      pay_type: [
        {
          name: "现金",
          payment_code: "cash",
          imgUrl: require("../../../../../../public/img/pay/xianjin.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: "微信",
          payment_code: "wxpay",
          imgUrl: require("../../../../../../public/img/pay/weixin.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: "支付宝",
          payment_code: "unionpay",
          imgUrl: require("../../../../../../public/img/pay/zhifu.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: "刷卡",
          payment_code: "pos",
          imgUrl: require("../../../../../../public/img/pay/yinhangka.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: "扫码支付",
          payment_code: "scan_pay",
          imgUrl: require("../../../../../../public/img/fukuan.png"),
          imgStatus: true, //true  显示图片 false显示文本
        },
      ],
      passwordPopStatus: false,
      forgetStatus: false,
      passwordForm: {
        confirmPassword: "",
        mobile: "",
        code: "",
        pay_pass: "",
        re_pay_pass: "",
      },
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      verificationTimer: null,
      timer: null,
      now_code: "",
      setStatus: false, //凑整设置
      nowIdx: "a",
      verificationStatus: false,
      verification_code: "",
    };
  },
  watch: {
    openIntegral(val) {
      if (val) {
        this.get_point();
      } else {
        this.dedIntegral = 0;
        this.dedIntegralMoney = 0;
      }
    },
    rechangeData(val) {
      console.log("我变化！！！", val);
      this.nowIdx = "a";
      this.rechangeData = val;
      // 优惠券显示问题
      if (val != "") {
        this.rechangeData.rule.forEach((item) => {
          let couponIds = item.coupon_ids ? item.coupon_ids.split(",") : []; //优惠券数组id
          if (item.coupon_status != 0) {
            let some = [];
            item.coupon_data.forEach((el) => {
              if (!some.some((e) => e.id == el.id)) {
                some.push(el);
              }
            });
            item.coupon_data = some;
            item.coupon_data.forEach((son) => {
              son.couponNum = 0;
              couponIds.forEach((grandSon) => {
                if (son.id == grandSon) son.couponNum += 1;
              });
            });
          }
        });
      }
      // let ruleData =
    },
  },
  mounted() {
    this.configuration();
  },
  methods: {
    // 关闭
    handleNote() {
      this.$confirm("确认关闭,不继续下单？")
        .then((_) => {
          // done();
          this.btn_status = false;
          this.timer = null;
          this.code_text = "获取验证码";
          this.verificationStatus = false;
          this.verification_code = "";
        })
        .catch((_) => {});
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.verificationTimer) {
        this.count = TIME_COUNT;
        // 向管理员发送验证码
        verificationCode.SendMyCode();
        this.verificationTimer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.verificationTimer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 选择充值项
    selectRechange(index) {
      if (index == this.nowIdx) {
        this.nowIdx = "a";
      } else {
        this.nowIdx = index;
      }
      this.$emit("sonChose", this.nowIdx);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          document.getElementById("qrcode").innerHTML = "";
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((_) => {});
    },
    handleClosePos(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          setTimeout(() => {
            location.reload();
          }, 500);
        })
        .catch((_) => {});
    },
    // 不使用优惠
    noCounpon() {
      this.drawer = false;
      this.couponradio = "";
      this.noUseconpon();
    },
    chosePayType(index) {
      this.payIndex = index;
    },
    configuration() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      getConfigButton(data).then((res) => {
        if (res.code == 200) {
          res.data.value.forEach((item) => {
            if (item.name == "cash_int") {
              this.setStatus = item.status == 1 ? true : false;
              console.log("配置 状态", this.setStatus);
            }
          });
        }
      });
    },
    // 向用户发送验证码
    async SendUserCode() {
      try {
        var data = {
          app_id: this.app_id,
          token: this.token,
          mobile: this.passwordForm.mobile,
        };
        const res = await iCSendSms(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    antiShake() {
      if (this.timer) {
        clearTimeout(this.timer); // 存在就清除执行fn的定时器
      } else {
        this.timer = setTimeout(() => {
          this.settleAccounts();
        }, 10);
      }
    },
    async settleAccounts() {
      if (!this.user_infor.uid) {
        this.$message.error("请输入用户信息");
        setTimeout(() => {
          this.timer = null;
        }, 200);
        return;
      }
      if (!this.recharge_info.type_id) {
        this.$message.error("请选择充值卡项");
        setTimeout(() => {
          this.timer = null;
        }, 200);
        return;
      }
      // return console.log(this.recharge_info);
      let data = {
        app_id: this.app_id,
        token: this.token,
        uid: this.user_infor.uid,
        account_type: this.recharge_info.account_type,
        payment_code: this.pay_type[this.payIndex].payment_code,
        charge_type: this.nowIdx == "a" ? "0" : "1",
        recharge_id: this.nowIdx == "a" ? "" : this.rechangeData.id,
        key: this.nowIdx == "a" ? "" : this.nowIdx,
        amount: this.inputPrice,
        money: this.send_money,
        account_id: this.recharge_info.account_id,
        operator_id: localStorage.getItem("choseStaffId")
          ? localStorage.getItem("choseStaffId")
          : "", //员工ID
      };
      // 新增现金短信验证
      // this.pay_type[this.payIndex].payment_code
      // 安全設置详情 储值现金;
      if (this.pay_type[this.payIndex].payment_code == "cash") {
        let cashOrderStatus = await verificationCode.get_detail(
          "open_cash_order"
        );
        if (cashOrderStatus && this.verification_code == "") {
          this.verificationStatus = true;
          this.$message.warning("请输入验证码！！");
          this.timer = null;
          return;
        } else {
          data.verification_code = this.verification_code;
        }
      }
      if (this.pay_type[this.payIndex].payment_code == "scan_pay") {
        this.dialogVisibleScancode = true;
        this.saomaForm = data;
        this.timer = null;
        this.$nextTick(() => {
          this.$refs.inputbox_pay.focus();
        });
        return;
      }
      rechargePay(data).then((res) => {
        // 短信弹窗
        this.btn_status = false;
        this.code_text = "获取验证码";
        this.verificationStatus = false;
        this.verification_code = "";
        if (res.code === 200) {
          console.log("typeOf", typeof res.data);
          if (res.data) {
            if (
              this.pay_type[this.payIndex].payment_code == "unionpay" ||
              this.pay_type[this.payIndex].payment_code == "wxpay"
            ) {
              this.dialogVisible = true;
              if (typeof res.data == "string") {
                this.$nextTick(() => {
                  let qrcode = new QRCode("qrcode", {
                    width: 360,
                    height: 360, // 高度
                    text: res.data, // 二维码内容
                  });
                });
              } else {
                this.$nextTick(() => {
                  let qrcode = new QRCode("qrcode", {
                    width: 360,
                    height: 360, // 高度
                    text: res.data.url, // 二维码内容
                  });
                });
              }
            } else {
              this.dialogVisiblePos = true;
            }
            let result = setInterval(() => {
              recharge_order_queryss({ order_id: res.order_id }).then((res) => {
                if (res.code == 200) {
                  clearInterval(result);
                  if (this.payIndex == 3) {
                    this.dialogVisiblePos = false;
                  } else {
                    this.dialogVisible = false;
                  }
                  this.$alert(
                    `${this.pay_type[this.payIndex].name}支付成功, 请用户查看${
                      this.pay_type[this.payIndex].name
                    }消息通知`,
                    "充值成功",
                    {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        this.timer = null;
                        location.reload();
                      },
                    }
                  );
                } else if (res.code == 202) {
                } else {
                  this.$message.error("支付失败");
                  if (this.payIndex == 3) {
                    this.dialogVisiblePos = false;
                  } else {
                    this.dialogVisible = false;
                  }
                }
              });
            }, 4000);
          } else {
            // 现金收款
            rechargeDetail({
              token: this.token,
              ordersn: res.order_id,
              app_id: this.app_id,
            }).then((res) => {
              this.$refs.pay_Success.orderData = res.data;
              this.$refs.pay_Success.paySuccess = true;
              this.timer = null;
              setTimeout(() => {
                location.reload();
              }, 2000);
            });
          }
        } else {
          this.$message.warning(res.msg);
          setTimeout(() => {
            this.timer = null;
          }, 200);
        }
      });
    },
    // 结账后刷新用户信息
    payEnd() {
      this.$emit("payEnd");
    },
    Blur() {
      this.$refs.inputbox_pay.focus();
    },
    //扫码支付
    async keyup_submit(val) {
      console.log(val);
      this.pay_code = val;
      this.loading = true;
      let data = {
        ...this.saomaForm,
        auth_code: this.pay_code,
      };
      console.log("saoma", data);
      const res = await rechargePay(data);
      if (res.code == 200) {
        let result1 = setInterval(() => {
          recharge_order_query({
            ordersn: res.order_id,
            app_id: this.app_id,
          }).then((status) => {
            if (status.code == 200) {
              this.pay_code = "";
              clearInterval(result1);
              this.loading = false;
              this.dialogVisibleScancode = false;
              this.$alert(
                `支付成功, 请用户查看${
                  this.pay_type[this.payIndex].name
                }消息通知`,
                "成功",
                {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.timer = null;
                    location.reload();
                  },
                }
              );
              // this.payEnd()
            } else if (status.code == 202) {
            } else {
              this.$message.error("支付失败");
              clearInterval(result1);
              this.timer = null;
              this.loading = false;
            }
          });
        }, 1000);
      } else if (res.code == 202) {
        let result2 = setInterval(() => {
          recharge_order_query({
            ordersn: res.order_id,
            app_id: this.app_id,
          }).then((status) => {
            if (status.code == 200) {
              this.pay_code = "";
              clearInterval(result2);
              this.loading = false;
              this.dialogVisibleScancode = false;
              this.$alert(
                `支付成功, 请用户查看${
                  this.pay_type[this.payIndex].name
                }消息通知`,
                "成功",
                {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.timer = null;
                    location.reload();
                  },
                }
              );
            } else if (status.code == 202) {
            } else {
              this.$message.error("支付失败");
              clearInterval(result2);
              this.timer = null;
              this.loading = false;
            }
          });
        }, 1000);
      } else {
        this.loading = false;
        this.pay_code = "";
        this.$refs.inputbox_pay.focus();
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./discount.scss");
.money-pay {
  flex: 1;
  height: auto;
  padding: 0 10px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .qrcode-con {
    max-width: 400px;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .box-card {
    margin-bottom: 10px;
    .el-card__body {
      padding: 10px 15px;
    }
    .pay-money {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        flex: 1;
        text-align: right;
        .el-input__inner {
          border: 0;
          text-align: right;
          color: #f56c6c;
          font-size: 30px;
        }
      }
    }
    .oilinfor {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      font-size: 18px;

      .oilinfor-name {
        color: #999;

        .oil {
          color: #e6a23c;
        }
      }
    }
    .weight {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      color: #999;
    }
  }
  .activityList {
    .activity-cont {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      line-height: 20px;
      height: 20px;
      .hint {
        font-size: 14px;
        color: #999;
        margin-right: 5px;
      }
    }
    .activity-cont:last-child {
      margin-bottom: 0px;
    }
  }
  .No_preferential {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #bfbfbf;
    font-size: 18px;
    border-radius: 5px;
    img {
      width: 20%;
    }
  }
  .preferential {
    width: 100%;
    padding: 10px;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .rechangeItem {
      width: 30%;
      height: 60px;
      border: 1px solid #ccc;
      margin-right: 3%;
      margin-bottom: 10px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
      .item {
        height: 60%;
      }
      .item2 {
        font-size: 14px;
      }
    }
    .rechangeItemActive {
      position: relative;
      text-align: center;
      // color: #409eff;
      background-color: #fff;
      box-shadow: 0px 2px 7px 0px rgba(85, 110, 97, 0.35);
      border-radius: 7px;
      border: 1px solid #409eff;
      .triangle:before {
        content: "";
        position: absolute;
        right: 0;
        bottom: 0;
        border: 17px solid #409eff;
        border-top-color: transparent;
        border-left-color: transparent;
      }
      .triangle:after {
        content: "";
        width: 5px;
        height: 12px;
        position: absolute;
        right: 6px;
        bottom: 6px;
        border: 2px solid #fff;
        border-top-color: transparent;
        border-left-color: transparent;
        transform: rotate(45deg);
      }
    }

    .option {
      width: 100%;
      min-height: 20px;
      color: #ff9746;
      background: #fffcf9;
    }
  }
  .pay_infor {
    margin-bottom: 10px;
    .pay_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        color: #f56c6c;
        span {
          font-size: 24px;
        }
      }
    }
    .pay_type {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      margin: 0 10px;
      background: #f3f3f3;
      border-radius: 5px;
      padding: 10px 0;
      border: 1px solid #d8d8d8;
      img {
        width: 40px;
      }
    }
    .pay_type_Active {
      border: 1px solid #409eff;
      background: #fff;
    }
  }
  .submitAccounts {
    .el-button {
      width: 100%;
      height: 70px;
      background: linear-gradient(90deg, #fd7f51, #fc3b39);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      img {
        width: 24px;
        margin-right: 10px;
      }
    }
  }
  .selectPay_type {
    display: flex;
    cursor: pointer;
    span {
      text-align: center;
    }
  }
}

.coupon_list {
  padding: 0 30px;
  height: 100%;
  overflow: auto;

  .el-radio-group {
    width: 100%;
  }
}
.noUseconpon {
  width: 100%;
  position: absolute;
  // height: 40px;
  bottom: 0;
  padding: 0 10px 10px;
  z-index: 9;

  .el-button {
    width: 100%;
  }
}
</style>

<style lang="scss">
.coupon-money {
  .el-input-number--mini {
    line-height: 20px;
  }
  .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
    border: 1px solid #378ae8;
    background-color: #ffffff3b;
    color: #fff;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    background: transparent;
    border: 0;
    color: #fff;
  }
}
.select_coupon {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .el-tabs__item {
    padding: 0 40px !important;
    font-size: 16px;
  }
}
.select_coupon-drawer {
  .el-drawer__header {
    margin-bottom: 16px;
  }
}
</style>
